import { GridColDef } from "@mui/x-data-grid";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { getStatusColor } from "../../../utils/functionHelper";
import { CustomDataGrid } from "../../../components/CustomDataGrid";
import { Menu, MenuItem, Stack } from "@mui/material";
import { Tabs } from "../../../components/Tabs";
import { CustomDateRangePicker } from "../../../components/CustomDateRangePicker";
import { dateToPosition } from "../../../utils/functionHelper"
import { baseURL } from "../../../config/api";
import { getCustomerServices } from "../../../services/Services";
import { getStatus } from "../../../services/Appointment";
import { getLocation } from "../../../services/Location";


const tabs = [
    {
        label: "All",
    },
    {
        label: "Scheduled",
    },
    {
        label: "Queued",
    },
    {
        label: "InProgress",
    },
    {
        label: "Done",
    },
    {
        label: "NoShow",
    },
    {
        label: "Cancelled",
    }
]

const filterItems = [
    {
        id: 0,
        label: "Service No",
    },
    {
        id: 1,
        label: "Customer Name",
    },
    {
        id: 2,
        label: "Assigned To",
    }
]


export const Financials = () => {
    const [searchTableData, setSearchTableData] = useState<any[]>([]);
    const [searchValue, setSearchValue] = useState<string>("");
    const [selectedFilter, setSelectedFilter] = useState<string>(filterItems[0].label);
    const [filterValue, setFilterValue] = useState(0);
    const [loading, setLoading] = useState(true);
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [activeTabLabel, setActiveTabLable] = useState<string>("All");
    const [currentIndex, setCurrentIndex] = useState<number>(0);
    const [locationId, setLocationId] = useState<number>(0);
    const [locationOptions, setLocationOptions] = useState<any[]>([]);
    const [serviceId, setServiceId] = useState<number>(0);
    const [serviceOptions, setServiceOptions] = useState<any[]>([]);
    const [status, setStatus] = useState<any[]>([]);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [showDateRangePicker, setShowDateRangePicker] = useState<boolean>(false);
    const [customStartDate, setCustomStartDate] = useState<string>(moment().startOf("month").subtract(1, 'month').format("MMM D, YYYY"));
    const [customEndDate, setCustomEndDate] = useState<string>(moment().format("MMM D, YYYY"));
    const [currentDateFormat, setCurrentDateFormat] = useState(
        customStartDate + " - " +
        customEndDate
    );
    const dateRangePickeref = useRef<HTMLDivElement | null>(null);
    const open = Boolean(anchorEl);
    const columns: GridColDef[] = [
        {
            field: "serviceNumber",
            headerName: "Service No.",
            flex: 1,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                return (
                    <Link to={`/admin/services/editservice?id=${params?.row?.appointmentID}`} className="underline text-[#0000ff]">
                        {params?.value}
                    </Link>
                );
            },
        },
        {
            field: "timeSlot",
            headerName: "Time",
            editable: false,
            sortable: false,
            flex: 1,
        },
        {
            field: "serviceName",
            headerName: "Service Name",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "firstName",
            headerName: "First Name",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "lastName",
            headerName: "Last Name",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "assignTo",
            headerName: "Assigned To",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "status",
            headerName: "Status",
            flex: 1,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                if (!params?.value) return;
                const color = getStatusColor(params.value);
                return (
                    <div className="flex items-end h-full">
                        <span className={`inline-flex text-xs px-[10px] py-[2px] rounded-xl font-semibold ${color.colorBg} ${color.colorText}`}>
                            {params.value}
                        </span>
                    </div>
                );
            }
        },
        {
            field: "serviceTotal",
            headerName: "$ Service Total",
            flex: 1,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                return (
                    params.id === 'summary' ? (
                        <span className="font-semibold">{params.value}</span>
                    )
                        : (
                            params.value
                        )
                )

            }
        },
        {
            field: "prodcutTotal",
            headerName: "$ Product Total",
            flex: 1,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                return (
                    params.id === 'summary' ? (
                        <span className="font-semibold">{params.value}</span>
                    )
                        : (
                            params.value
                        )
                )

            }
        },
        {
            field: "subTotal",
            headerName: "$ Subtotal",
            flex: 1,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                return (
                    params.id === 'summary' ? (
                        <span className="font-semibold">{params.value}</span>
                    )
                        : (
                            params.value
                        )
                )

            }
        },
        {
            field: "taxAmount",
            headerName: "$ Tax Amount",
            type: "number",
            flex: 1,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                return (
                    params.id === 'summary' ? (
                        <span className="font-semibold">{params.value}</span>
                    )
                        : (
                            params.value
                        )
                )

            }
        },
        {
            field: "totalAmount",
            headerName: "$ Total Amount",
            type: "number",
            flex: 1,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                return (
                    params.id === 'summary' ? (
                        <span className="font-semibold">{params.value}</span>
                    )
                        : (
                            params.value
                        )
                )

            }
        },
        {
            field: "balanceDue",
            headerName: "$ Balance Due",
            type: "number",
            flex: 1,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                return (
                    params.id === 'summary' ? (
                        <span className="font-semibold">{params.value}</span>
                    )
                        : (
                            params.value
                        )
                )

            }
        },
        {
            field: "amountPaid",
            headerName: "$ Amount Paid",
            type: "number",
            flex: 1,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                return (
                    params.id === 'summary' ? (
                        <span className="font-semibold">{params.value}</span>
                    )
                        : (
                            params.value
                        )
                )

            }
        },

    ];

    useEffect(() => {
        getLocation()
            .then((data) => {
                setLocationOptions(() => data?.map((loc: any) => {
                    return {
                        value: loc?.id,
                        label: loc?.locationName
                    }
                }))
            })
            .catch((error) => {
                console.error(error)
            })
    }, [])


    useEffect(() => {
        getStatus("Appointment")
            .then((data) => {
                setStatus(() => data?.map((status: any) => {
                    return {
                        id: status.statusID,
                        statusValue: status.statusValue
                    }
                }))
            })
            .catch((error) => {
                console.error(error)
            })
    }, [])

    useEffect(() => {
        getCustomerServices()
            .then((data) => {
                setServiceOptions(() => data?.map((service: any) => {
                    return {
                        value: service?.serviceID,
                        label: service?.serviceName
                    }
                }))
            }).catch((error) => {
                setServiceOptions([]);
                console.error(error);
            })
    }, [])

    useEffect(() => {
        const handleDropDown = (e: MouseEvent) => {
            if (!dateRangePickeref.current?.contains(e.target as Node)) setShowDateRangePicker(false);
        }

        document.addEventListener("click", handleDropDown);
        return () => document.removeEventListener("click", handleDropDown);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const hanbleTabChange = (index: number, tab: any) => {
        setActiveIndex(tab?.id || index);
        setActiveTabLable(tab?.label);
        setCurrentIndex(index);
    }

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        let timeOutId: NodeJS.Timeout;

        if (searchValue !== "") {
            timeOutId = setTimeout(() => {
                filterApiCall();
            }, 1000);
        }

        return () => clearTimeout(timeOutId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    useEffect(() => {
        if (searchValue !== "") {
            filterApiCall();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locationId, customStartDate, customEndDate, activeIndex, serviceId])

    const filterApiCall = () => {
        switch (filterValue) {
            case 0:
                if (locationId > 0 && serviceId === 0) {
                    if (customStartDate && customEndDate && activeIndex === 0) {
                        setLoading(true);
                        const startDate = moment(customStartDate).format('YYYY-MM-DD');
                        const endDate = moment(customEndDate).format('YYYY-MM-DD');
                        getAppointmentData(`appointments/GetApointmentsReportByLocationIdAndAppoinmentDateRangeAndSearchByServiceNumber?serviceNumber=${searchValue}&locationId=${locationId}&startDate=${startDate}&endDate=${endDate}`);
                    }
                    else if (customStartDate && customEndDate && activeIndex > 0) {
                        setLoading(true);
                        const startDate = moment(customStartDate).format('YYYY-MM-DD');
                        const endDate = moment(customEndDate).format('YYYY-MM-DD');
                        const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                        getAppointmentData(`appointments/GetApointmentsReportByLocationIdAndAppoinmentDateRangeAndStatusAndSearchByServiceNumber?serviceNumber=${searchValue}&locationId=${locationId}&startDate=${startDate}&endDate=${endDate}&statusId=${statusId}`);
                    }
                }
                else if (locationId > 0 && serviceId > 0) {
                    if (customStartDate && customEndDate && activeIndex === 0) {
                        setLoading(true);
                        const startDate = moment(customStartDate).format('YYYY-MM-DD');
                        const endDate = moment(customEndDate).format('YYYY-MM-DD');
                        getAppointmentData(`appointments/GetApointmentsReportByLocationIdAndAppoinmentDateRangeAndServiceTypeAndSearchByServiceNumber?serviceNumber=${searchValue}&locationId=${locationId}&startDate=${startDate}&endDate=${endDate}&seviceTypeId=${serviceId}`);
                    }
                    else if (customStartDate && customEndDate && activeIndex > 0) {
                        setLoading(true);
                        const startDate = moment(customStartDate).format('YYYY-MM-DD');
                        const endDate = moment(customEndDate).format('YYYY-MM-DD');
                        const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                        getAppointmentData(`appointments/GetApointmentsReportByLocationIdAndAppoinmentDateRangeAndStatusAndServiceTypeAndSearchByServiceNumber?serviceNumber=${searchValue}&locationId=${locationId}&startDate=${startDate}&endDate=${endDate}&statusId=${statusId}&seviceTypeId=${serviceId}`);
                    }
                }
                else if (serviceId > 0 && locationId === 0) {
                    if (customStartDate && customEndDate && activeIndex === 0) {
                        setLoading(true);
                        const startDate = moment(customStartDate).format('YYYY-MM-DD');
                        const endDate = moment(customEndDate).format('YYYY-MM-DD');
                        getAppointmentData(`appointments/GetApointmentsReportByAppoinmentDateRangeAndServcieIdAndSearchByServiceNumber?serviceNumber=${searchValue}&startDate=${startDate}&endDate=${endDate}&serviceTypeId=${serviceId}`);
                    }
                    else if (customStartDate && customEndDate && activeIndex > 0) {
                        setLoading(true);
                        const startDate = moment(customStartDate).format('YYYY-MM-DD');
                        const endDate = moment(customEndDate).format('YYYY-MM-DD');
                        const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                        getAppointmentData(`appointments/GetApointmentsReportByAppoinmentDateRangeAndServcieIdAndStatusAndSearchByServiceNumber?serviceNumber=${searchValue}&startDate=${startDate}&endDate=${endDate}&statusId=${statusId}&serviceTypeId=${serviceId}`);
                    }
                }
                else {
                    if (customStartDate && customEndDate && activeIndex === 0) {
                        setLoading(true);
                        const startDate = moment(customStartDate).format('YYYY-MM-DD');
                        const endDate = moment(customEndDate).format('YYYY-MM-DD');
                        getAppointmentData(`appointments/GetApointmentsReportByAppoinmentDateRangeAndSearchByServiceNumber?serviceNumber=${searchValue}&startDate=${startDate}&endDate=${endDate}`);
                    }
                    else if (customStartDate && customEndDate && activeIndex > 0) {
                        setLoading(true);
                        const startDate = moment(customStartDate).format('YYYY-MM-DD');
                        const endDate = moment(customEndDate).format('YYYY-MM-DD');
                        const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                        getAppointmentData(`appointments/GetApointmentsReportByAppoinmentDateRangeAndStatusAndSearchByServiceNumber?serviceNumber=${searchValue}&startDate=${startDate}&endDate=${endDate}&statusId=${statusId}`);
                    }
                }
                break;
            case 1:
                if (locationId > 0 && serviceId === 0) {
                    if (customStartDate && customEndDate && activeIndex === 0) {
                        setLoading(true);
                        const startDate = moment(customStartDate).format('YYYY-MM-DD');
                        const endDate = moment(customEndDate).format('YYYY-MM-DD');
                        getAppointmentData(`appointments/GetApointmentsReportByLocationIdAndAppoinmentDateRangeAndSearchByCustomerName?customerName=${searchValue}&locationId=${locationId}&startDate=${startDate}&endDate=${endDate}`);
                    }
                    else if (customStartDate && customEndDate && activeIndex > 0) {
                        setLoading(true);
                        const startDate = moment(customStartDate).format('YYYY-MM-DD');
                        const endDate = moment(customEndDate).format('YYYY-MM-DD');
                        const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                        getAppointmentData(`appointments/GetApointmentsReportByLocationIdAndAppoinmentDateRangeAndStatusAndSearchByCustomerName?customerName=${searchValue}&locationId=${locationId}&startDate=${startDate}&endDate=${endDate}&statusId=${statusId}`);
                    }
                }
                else if (locationId > 0 && serviceId > 0) {
                    if (customStartDate && customEndDate && activeIndex === 0) {
                        setLoading(true);
                        const startDate = moment(customStartDate).format('YYYY-MM-DD');
                        const endDate = moment(customEndDate).format('YYYY-MM-DD');
                        getAppointmentData(`appointments/GetApointmentsReportByLocationIdAndAppoinmentDateRangeAndServiceTypeAndSearchByCustomerName?customerName=${searchValue}&locationId=${locationId}&startDate=${startDate}&endDate=${endDate}&seviceTypeId=${serviceId}`);
                    }
                    else if (customStartDate && customEndDate && activeIndex > 0) {
                        setLoading(true);
                        const startDate = moment(customStartDate).format('YYYY-MM-DD');
                        const endDate = moment(customEndDate).format('YYYY-MM-DD');
                        const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                        getAppointmentData(`appointments/GetApointmentsReportByLocationIdAndAppoinmentDateRangeAndStatusAndServiceTypeAndSearchByCustomerName?customerName=${searchValue}&locationId=${locationId}&startDate=${startDate}&endDate=${endDate}&statusId=${statusId}&seviceTypeId=${serviceId}`);
                    }
                }
                else if (locationId === 0 && serviceId > 0) {
                    if (customStartDate && customEndDate && activeIndex === 0) {
                        setLoading(true);
                        const startDate = moment(customStartDate).format('YYYY-MM-DD');
                        const endDate = moment(customEndDate).format('YYYY-MM-DD');
                        getAppointmentData(`appointments/GetApointmentsReportByAppoinmentDateRangeAndServcieIdAndSearchByCustomerName?customerName=${searchValue}&startDate=${startDate}&endDate=${endDate}&serviceTypeId=${serviceId}`);
                    }
                    else if (customStartDate && customEndDate && activeIndex > 0) {
                        setLoading(true);
                        const startDate = moment(customStartDate).format('YYYY-MM-DD');
                        const endDate = moment(customEndDate).format('YYYY-MM-DD');
                        const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                        getAppointmentData(`appointments/GetApointmentsReportByAppoinmentDateRangeAndServcieIdAndStatusAndSearchByCustomerName?customerName=${searchValue}&startDate=${startDate}&endDate=${endDate}&statusId=${statusId}&serviceTypeId=${serviceId}`);
                    }
                }
                else {
                    if (customStartDate && customEndDate && activeIndex === 0) {
                        setLoading(true);
                        const startDate = moment(customStartDate).format('YYYY-MM-DD');
                        const endDate = moment(customEndDate).format('YYYY-MM-DD');
                        getAppointmentData(`appointments/GetApointmentsReportByAppoinmentDateRangeAndSearchByCustomerName?customerName=${searchValue}&startDate=${startDate}&endDate=${endDate}`);
                    }
                    else if (customStartDate && customEndDate && activeIndex > 0) {
                        setLoading(true);
                        const startDate = moment(customStartDate).format('YYYY-MM-DD');
                        const endDate = moment(customEndDate).format('YYYY-MM-DD');
                        const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                        getAppointmentData(`appointments/GetApointmentsReportByAppoinmentDateRangeAndStatusAndSearchByCustomerName?customerName=${searchValue}&startDate=${startDate}&endDate=${endDate}&statusId=${statusId}`);
                    }
                }
                break;
            case 2:
                if (locationId > 0 && serviceId === 0) {
                    if (customStartDate && customEndDate && activeIndex === 0) {
                        setLoading(true);
                        const startDate = moment(customStartDate).format('YYYY-MM-DD');
                        const endDate = moment(customEndDate).format('YYYY-MM-DD');
                        getAppointmentData(`appointments/GetApointmentsReportByLocationIdAndAppoinmentDateRangeAndSearchByEmployeeName?employeeName=${searchValue}&locationId=${locationId}&startDate=${startDate}&endDate=${endDate}`);
                    }
                    else if (customStartDate && customEndDate && activeIndex > 0) {
                        setLoading(true);
                        const startDate = moment(customStartDate).format('YYYY-MM-DD');
                        const endDate = moment(customEndDate).format('YYYY-MM-DD');
                        const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                        getAppointmentData(`appointments/GetApointmentsReportByLocationIdAndAppoinmentDateRangeAndStatusAndSearchByEmployeeName?employeeName=${searchValue}&locationId=${locationId}&startDate=${startDate}&endDate=${endDate}&statusId=${statusId}`);
                    }
                }
                else if (locationId > 0 && serviceId > 0) {
                    if (customStartDate && customEndDate && activeIndex === 0) {
                        setLoading(true);
                        const startDate = moment(customStartDate).format('YYYY-MM-DD');
                        const endDate = moment(customEndDate).format('YYYY-MM-DD');
                        getAppointmentData(`appointments/GetApointmentsReportByLocationIdAndAppoinmentDateRangeAndServiceTypeAndSearchByEmployeeName?employeeName=${searchValue}&locationId=${locationId}&startDate=${startDate}&endDate=${endDate}&seviceTypeId=${serviceId}`);
                    }
                    else if (customStartDate && customEndDate && activeIndex > 0) {
                        setLoading(true);
                        const startDate = moment(customStartDate).format('YYYY-MM-DD');
                        const endDate = moment(customEndDate).format('YYYY-MM-DD');
                        const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                        getAppointmentData(`appointments/GetApointmentsReportByLocationIdAndAppoinmentDateRangeAndStatusAndServiceTypeAndSearchByEmployeeName?employeeName=${searchValue}&locationId=${locationId}&startDate=${startDate}&endDate=${endDate}&statusId=${statusId}&seviceTypeId=${serviceId}`);
                    }
                }
                else if (serviceId > 0 && locationId === 0) {
                    if (customStartDate && customEndDate && activeIndex === 0) {
                        setLoading(true);
                        const startDate = moment(customStartDate).format('YYYY-MM-DD');
                        const endDate = moment(customEndDate).format('YYYY-MM-DD');
                        getAppointmentData(`appointments/GetApointmentsReportByAppoinmentDateRangeAndServcieIdAndSearchByEmployeeName?employeeName=${searchValue}&startDate=${startDate}&endDate=${endDate}&serviceTypeId=${serviceId}`);
                    }
                    else if (customStartDate && customEndDate && activeIndex > 0) {
                        setLoading(true);
                        const startDate = moment(customStartDate).format('YYYY-MM-DD');
                        const endDate = moment(customEndDate).format('YYYY-MM-DD');
                        const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                        getAppointmentData(`appointments/GetApointmentsReportByAppoinmentDateRangeAndServcieIdAndStatusAndSearchByEmployeeName?employeeName=${searchValue}&startDate=${startDate}&endDate=${endDate}&statusId=${statusId}&serviceTypeId=${serviceId}`);
                    }
                }
                else {
                    if (customStartDate && customEndDate && activeIndex === 0) {
                        setLoading(true);
                        const startDate = moment(customStartDate).format('YYYY-MM-DD');
                        const endDate = moment(customEndDate).format('YYYY-MM-DD');
                        getAppointmentData(`appointments/GetApointmentsReportByAppoinmentDateRangeAndSearchByEmployeeName?employeeName=${searchValue}&startDate=${startDate}&endDate=${endDate}`);
                    }
                    else if (customStartDate && customEndDate && activeIndex > 0) {
                        setLoading(true);
                        const startDate = moment(customStartDate).format('YYYY-MM-DD');
                        const endDate = moment(customEndDate).format('YYYY-MM-DD');
                        const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                        getAppointmentData(`appointments/GetApointmentsReportByAppoinmentDateRangeAndStatusAndSearchByEmployeeName?employeeName=${searchValue}&startDate=${startDate}&endDate=${endDate}&statusId=${statusId}`);
                    }
                }
                break;
        }

    }

    useEffect(() => {
        if (searchValue === "") {
            emptySearchApiCall();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locationId, customStartDate, customEndDate, activeIndex, serviceId, searchValue])

    const emptySearchApiCall = () => {
        if (locationId > 0 && serviceId === 0) {
            if (customStartDate && customEndDate && activeIndex === 0) {
                setLoading(true);
                const startDate = moment(customStartDate).format('YYYY-MM-DD');
                const endDate = moment(customEndDate).format('YYYY-MM-DD');
                getAppointmentData(`appointments/GetApointmentsReportByLocationIdAndAppoinmentDateRange?locationId=${locationId}&startDate=${startDate}&endDate=${endDate}`);
            }
            else if (customStartDate && customEndDate && activeIndex > 0) {
                setLoading(true);
                const startDate = moment(customStartDate).format('YYYY-MM-DD');
                const endDate = moment(customEndDate).format('YYYY-MM-DD');
                const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                getAppointmentData(`appointments/GetApointmentsReportByLocationIdAndAppoinmentDateRangeAndStatus?locationId=${locationId}&startDate=${startDate}&endDate=${endDate}&statusId=${statusId}`);
            }
        }
        else if (locationId > 0 && serviceId > 0) {
            if (customStartDate && customEndDate && activeIndex === 0) {
                setLoading(true);
                const startDate = moment(customStartDate).format('YYYY-MM-DD');
                const endDate = moment(customEndDate).format('YYYY-MM-DD');
                getAppointmentData(`appointments/GetApointmentsReportByLocationIdAndAppoinmentDateRangeAndServiceType?locationId=${locationId}&startDate=${startDate}&endDate=${endDate}&seviceTypeId=${serviceId}`);
            }
            else if (customStartDate && customEndDate && activeIndex > 0) {
                setLoading(true);
                const startDate = moment(customStartDate).format('YYYY-MM-DD');
                const endDate = moment(customEndDate).format('YYYY-MM-DD');
                const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                getAppointmentData(`appointments/GetApointmentsReportByLocationIdAndAppoinmentDateRangeAndStatusAndServiceType?locationId=${locationId}&startDate=${startDate}&endDate=${endDate}&statusId=${statusId}&seviceTypeId=${serviceId}`);
            }
        }
        else if (locationId === 0 && serviceId > 0) {
            if (customStartDate && customEndDate && activeIndex === 0) {
                setLoading(true);
                const startDate = moment(customStartDate).format('YYYY-MM-DD');
                const endDate = moment(customEndDate).format('YYYY-MM-DD');
                getAppointmentData(`appointments/GetApointmentsReportByAppoinmentDateRangeAndServcieId?startDate=${startDate}&endDate=${endDate}&serviceTypeId=${serviceId}`);
            }
            else if (customStartDate && customEndDate && activeIndex > 0) {
                setLoading(true);
                const startDate = moment(customStartDate).format('YYYY-MM-DD');
                const endDate = moment(customEndDate).format('YYYY-MM-DD');
                const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                getAppointmentData(`appointments/GetApointmentsReportByAppoinmentDateRangeAndServcieIdAndStatus?startDate=${startDate}&endDate=${endDate}&statusId=${statusId}&serviceTypeId=${serviceId}`);
            }
        }
        else {
            if (customStartDate && customEndDate && activeIndex === 0) {
                setLoading(true);
                const startDate = moment(customStartDate).format('YYYY-MM-DD');
                const endDate = moment(customEndDate).format('YYYY-MM-DD');
                getAppointmentData(`appointments/GetApointmentsReportByAppoinmentDateRange?startDate=${startDate}&endDate=${endDate}`);
            }
            else if (customStartDate && customEndDate && activeIndex > 0) {
                setLoading(true);
                const startDate = moment(customStartDate).format('YYYY-MM-DD');
                const endDate = moment(customEndDate).format('YYYY-MM-DD');
                const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                getAppointmentData(`appointments/GetApointmentsReportByAppoinmentDateRangeAndStatus?startDate=${startDate}&endDate=${endDate}&statusId=${statusId}`);
            }
        }
    }

    const getAppointmentData = (apiUrl: string) => {
        let summaryServiceTotal = 0;
        let summaryProductTotal = 0;
        let summarySubTotal = 0;
        let summaryTax = 0;
        let summaryTotal = 0;
        let summaryBalanceDue = 0;
        let summaryAmountPaid = 0;
        fetch(`${baseURL}${apiUrl}`)
            .then((res) => res.json())
            .then((data) => {
                const result = data?.map((item: any) => {
                    summaryServiceTotal += item?.invoice?.serviceTotal ? item?.invoice?.serviceTotal : 0;
                    summaryProductTotal += item?.invoice?.prodcutTotal ? item?.invoice?.prodcutTotal : 0;
                    summarySubTotal += item?.invoice?.subTotal ? item?.invoice?.subTotal : 0;
                    summaryTax += item?.invoice?.taxAmount ? item?.invoice?.taxAmount : 0;
                    summaryTotal += item?.invoice?.totalAmount ? item?.invoice?.totalAmount : 0;
                    summaryBalanceDue += item?.invoice?.balanceDue ? item?.invoice?.balanceDue : 0;
                    summaryAmountPaid += item?.invoice?.amountPaid ? item?.invoice?.amountPaid : 0;
                    return {
                        ...item,
                        id: item?.appointmentID,
                        timeSlot: moment(item?.timeSlot, "HH:mm").format("hh:mm A"),
                        appointmentDate: moment(new Date(item?.appointmentDate)).format("MM/DD/YYYY"),
                        firstName: item?.customer ? item?.customer?.firstName : "",
                        lastName: item?.customer ? item?.customer?.lastName : "",
                        phone: item?.customer ? item?.customer?.phone : "",
                        email: item?.customer ? item?.customer?.email : "",
                        assignTo: item?.workOrder?.employeeName ? item?.workOrder?.employeeName : "",
                        serviceTotal: item?.invoice?.serviceTotal ? item?.invoice?.serviceTotal : 0,
                        prodcutTotal: item?.invoice?.prodcutTotal ? item?.invoice?.prodcutTotal : 0,
                        subTotal: item?.invoice?.subTotal ? item?.invoice?.subTotal : 0,
                        taxAmount: item?.invoice?.taxAmount ? item?.invoice?.taxAmount : 0,
                        totalAmount: item?.invoice?.totalAmount ? item?.invoice?.totalAmount : 0,
                        balanceDue: item?.invoice?.balanceDue ? item?.invoice?.balanceDue : 0,
                        amountPaid: item?.invoice?.amountPaid ? item?.invoice?.amountPaid : 0,

                    };
                })

                const summary = {
                    id: 'summary',
                    timeSlot: '',
                    appointmentDate: '',
                    firstName: '',
                    lastName: '',
                    phone: '',
                    email: '',
                    assignTo: '',
                    status: '',
                    serviceTotal: `$${summaryServiceTotal.toFixed(2)}`,
                    prodcutTotal: `$${summaryProductTotal.toFixed(2)}`,
                    subTotal: `$${summarySubTotal.toFixed(2)}`,
                    taxAmount: `$${summaryTax.toFixed(2)}`,
                    totalAmount: `$${summaryTotal.toFixed(2)}`,
                    balanceDue: `$${summaryBalanceDue.toFixed(2)}`,
                    amountPaid: `$${summaryAmountPaid.toFixed(2)}`,

                }
                result.push(summary)
                setSearchTableData(result);
                setLoading(false);
            })
            .catch(error => {
                setSearchTableData([]);
                setLoading(false);
                console.error(error);
            });


    }

    return (
        <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
            <div className="w-full h-full bg-white p-4 rounded-md">
                <div className="flex items-center justify-between py-2">
                    <div className="w-full">
                        <Tabs tabs={tabs} onChange={(index, tab) => hanbleTabChange(index, tab)} activeIndex={currentIndex} />
                    </div>
                    <div className="flex items-center gap-1.5">
                        <div>
                            <select
                                value={serviceId}
                                onChange={(e) => setServiceId(Number(e.target.value))}
                                className="w-[160px] border border-gray-300 rounded-md p-3 text-sm outline-none focus:border-primary bg-white"
                            >
                                <option value={0}>
                                    All
                                </option>
                                {serviceOptions.map((service: any, index: number) => (
                                    <option key={index} value={service?.value}>
                                        {service?.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <select
                                value={locationId}
                                onChange={(e) => setLocationId(Number(e.target.value))}
                                className="w-[170px] border border-gray-300 rounded-md p-3 text-sm outline-none focus:border-primary bg-white"
                            >
                                <option value={0}>
                                    All
                                </option>
                                {locationOptions.map((loc: any, index: number) => (
                                    <option key={index} value={loc?.value}>
                                        {loc?.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div ref={dateRangePickeref}>
                            <div
                                className={`px-[4px] py-[10px] rounded-lg relative border border-gray-300 flex items-center gap-1.5 cursor-pointer`}
                                onClick={() => setShowDateRangePicker(!showDateRangePicker)}
                            >
                                <span className="text-xs text-nowrap font-medium">
                                    {currentDateFormat}
                                </span>
                                <span className="material-symbols-outlined text-[25px] font-extralight">
                                    date_range
                                </span>

                            </div>
                            <CustomDateRangePicker
                                zIndex={156}
                                intialStartDate={customStartDate}
                                intialEndDate={customEndDate}
                                showDateRangePicker={showDateRangePicker}
                                setShowDateRangePicker={setShowDateRangePicker}
                                setDateRange={(startDate, endDate) => {
                                    setCustomStartDate(startDate);
                                    setCustomEndDate(endDate);
                                    const differentInDays = dateToPosition(moment(startDate), moment(endDate));
                                    if (differentInDays <= 0) {
                                        setCurrentDateFormat(
                                            moment(startDate).format('MMM D, YYYY')
                                        );
                                    } else {
                                        setCurrentDateFormat(
                                            moment(startDate).format('MMM D, YYYY') +
                                            moment(endDate).format(' - MMM D, YYYY')
                                        );
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className={`w-full border border-[#E4E7EC] rounded-[16px]`}>
                    <div className={`flex justify-between items-center p-4 border-b border-[#E4E7EC]`}>
                        <div className="flex items-center gap-1.5">

                            <h2 className={`text-lg font-semibold text-[#1D2939]`}>Financials</h2>
                        </div>
                        <div className="flex items-center gap-1.5">
                            <div >
                                <button
                                    className={`flex items-center justify-between py-[5px] px-[12px] gap-2.5 rounded-lg border border-solid`}
                                    aria-controls={open ? 'basic-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                    onClick={handleClick}
                                >
                                    <Stack
                                        direction="row"
                                        spacing={1}
                                        alignItems={"center"}
                                        justifyContent={"center"}
                                    >
                                        <span className={` text-[14px] font-medium text-black-rgba`}>{selectedFilter}</span>
                                        {open ? <span className={`material-symbols-outlined  text-[25px] font-extralight`}>
                                            keyboard_arrow_up
                                        </span> : <span className={`material-symbols-outlined  text-[25px] font-extralight`}>
                                            keyboard_arrow_down
                                        </span>}
                                    </Stack>
                                </button>

                                <Menu
                                    id="basic-menu"
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleClose}
                                    slotProps={{
                                        paper: {
                                            sx: {
                                                width: 170,
                                            }
                                        }
                                    }}
                                >
                                    {
                                        filterItems?.map((filter, index) => (
                                            <>
                                                <MenuItem
                                                    key={index}
                                                    sx={{ fontSize: "12px", marginBlock: "0px" }}
                                                    onClick={() => {
                                                        setSelectedFilter(filter.label)
                                                        setFilterValue(filter.id)
                                                        setAnchorEl(null);

                                                    }}>
                                                    <span className={`text-[16px] font-medium text-black-rgba`}>{filter.label}</span>
                                                </MenuItem>

                                            </>

                                        ))
                                    }
                                </Menu>
                            </div>
                            <div className={`flex px-[5px] py-[6px] items-center gap-2.5 rounded-lg border shadow-sm`}>
                                <span className={`material-symbols-outlined text-[25px] font-light text-black-rgba`}>
                                    search
                                </span>
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    className={`border-none outline-none w-full bg-transparent`}
                                    onChange={(e) => setSearchValue(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                    <CustomDataGrid
                        filteredRows={searchTableData}
                        columns={columns?.map(col => ({
                            ...col,
                            headerClassName: "bg-[#F9FAFB]",
                        }))}
                        loading={loading}
                    />
                </div>
            </div>

        </div>
    )
}